import React from "react";

const NumberInput = ({
  name,
  id = "",
  label,
  value,
  type = "number",
  handleChange,
  placeholder = "",
  required = false,
  disabled = false,
  maxLength,
  errorMessage = {},
  handleBlur,
  maxValue,
}) => {
  const preventInvalidKeys = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <div>
      <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div>
        <input
          type={type}
          className={`form-control mb-5px fs-5 ${
            errorMessage[name]?.trim()?.length > 0 ? "input-error" : ""
          }`}
          placeholder={placeholder}
          name={name}
          id={id}
          value={value}
          onChange={handleChange}
          onKeyDown={preventInvalidKeys}
          inputMode="numeric"
          pattern="[0-9]*"
          // required={required}
          disabled={disabled}
          maxLength={maxLength}
          max={maxValue}
          step="0.01"
          onBlur={handleBlur}
          onInput={(e) => {
            if (e.target.value > maxValue) {
              e.target.value = maxValue;
              handleChange(e);
            }
          }}
        />
      </div>
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6 mt-1">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
};

export default NumberInput;
